export default "__VITE_ASSET__BAyXXyxH__"